module.exports = __webpack_public_path__ + "img/03.2d6762a3.png";